import { render, staticRenderFns } from "./School.vue?vue&type=template&id=2a14aabe&scoped=true&lang=pug&"
import script from "./School.vue?vue&type=script&lang=ts&"
export * from "./School.vue?vue&type=script&lang=ts&"
import style0 from "./School.vue?vue&type=style&index=0&id=2a14aabe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a14aabe",
  null
  
)

export default component.exports